/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import styled from "styled-components";
import { BsArrowLeftCircleFill, BsArrowRightCircleFill } from "react-icons/bs";

interface Props {
  value: "left" | "right";
}

const DescButton = ({ value }: Props) => {
  return (
    <Button>
      {value === "left" && <BsArrowLeftCircleFill />}
      {value === "right" && <BsArrowRightCircleFill />}
    </Button>
  );
};

export default DescButton;

const Button = styled.button`
  cursor: pointer;
  background-color: transparent;
  border: none;

  font-size: 60px;

  display: flex;
  align-items: center;
  justify-content: center;

  color: #00000060;
`;
